import { render, staticRenderFns } from "./signTab.vue?vue&type=template&id=0baa3794&scoped=true&"
import script from "./signTab.vue?vue&type=script&lang=js&"
export * from "./signTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa3794",
  null
  
)

export default component.exports